interface BasicParams {
  mon_line: string;
  mon_scene: string;
  mon_type: 'api' | 'sdk' | 'jsbridge';
  mon_status: 'success' | 'fail';
}
interface ApiParams {
  mon_api_url: string;
  mon_api_req_params?: object;
  mon_api_res_code?: string;
  mon_api_res_msg?: string;
  mon_api_res_t?: string;
  mon_axios_error?: ApiAxiosErrData;
}
interface SdkParams {
  mon_sdk_name: string;
  mon_sdk_msg: string;
  mon_sdk_code: string;
  mon_sdk_status: string;
}
interface JsBridgeParams {
  mon_jsbridge_name: string;
  mon_jsbridge_params?: object;
  mon_jsbridge_code: string;
  mon_jsbridge_msg: string;
}
// 整合类型
type PointsTrackParams =
  | (BasicParams & ApiParams)
  | (BasicParams & SdkParams)
  | (BasicParams & JsBridgeParams);

interface ApiAxiosErrData {
  type: 'err_res' | 'err_req' | 'err_other';
  msg: string;
  data: any;
}

const eventName = 'key_points_collect';

export function onPointsTrack(
  sensorTrack: any,
  params: PointsTrackParams
): void {
  sensorTrack(eventName, params);
}
